<template>
    <div class="card mt-3" style="margin-bottom:10px">
        <div class=" card-body">
            
                
				<dashboard-atencion />
				
            
        </div>
    </div>
</template>


<script>
/* eslint-disable */
import DashboardAtencion from './PerfilAtencion.vue'

export default {
    name: "Dashboard-Atencion",
    components: {
        DashboardAtencion
    },

    data() {
        return {
            loading: true,
            isMobile: this.$isMobile,

        };
    },
    computed: {},
    watch: {},

    activated() { },
    mounted() {


        if (this.isMobile) {
            this.$eventBus.emit("activeShowMenu");
        }
    },
    methods: {

    }

}



</script>


<style></style>
